/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_DetailInputs */

const en_landing_studio_detail = /** @type {(inputs: Landing_Studio_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt detail`)
};

const zh_landing_studio_detail = /** @type {(inputs: Landing_Studio_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示词扩写`)
};

/**
* | output |
* | --- |
* | "Prompt detail" |
*
* @param {Landing_Studio_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_detail = /** @type {((inputs?: Landing_Studio_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_detail(inputs)
	return zh_landing_studio_detail(inputs)
});
export { landing_studio_detail as "landing.studio.detail" }